<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.ivu-message {
  font-family: 'Courier New', Courier, monospace !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue